import React from 'react'
import { Link } from '~components'
import styled from 'styled-components/macro'
import { Box } from '~styled'

export const SignupButtonWrapper = styled(Box)`
    .btn{
        min-width:auto;
        height: 45px;
        border-radius: 55px;
        font-size: 20px;
        font-weight: 400;
        display:flex;
        align-items:center;
        justify-content:center;
        padding-left:15px;
        padding-right:15px;
        letter-spacing: -0.4px;
        margin-left:10px;
        margin-top: 40px;
        color:#262729;
        min-width: 120px;
        @media (min-width: 992px){
            font-size: 26px;
            height: 90px;
            min-width: 194px;
        }
        &-2{
            color:#fff;
            background-color: #0052cc;
            border-color: #0052cc;
            &:hover{
                box-shadow: 0 0px 0px rgba(241, 139, 98, 0.3);
            }
        }
    }
`
const SignupButton = ({btnLink,btnText,...rest})=>{
    return(
        <SignupButtonWrapper {...rest}>
            <Link target="_blank" className="btn btn-2" to={btnLink ? btnLink : "/"}>
                {btnText}
            </Link>
        </SignupButtonWrapper>
    )
}

export default SignupButton;